import { useIntl } from 'react-intl';
import type { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';
import FieldLabel from '@/shared/components/FieldLabel';
import FieldError from '@/shared/components/FieldError';
import { inputClass } from '@/shared/utils/styles';
import { hasFieldError, type ServerErrors } from '@/shared/utils/fieldErrors';

interface Props<T extends FieldValues> {
  register: UseFormRegister<T>;
  errors: FieldErrors;
  serverErrors: ServerErrors;
}

export default function EmailField<T extends { email: string }>({
  register,
  errors,
  serverErrors,
}: Props<T>) {
  const intl = useIntl();

  return (
    <div>
      <FieldLabel htmlFor="email" labelId="auth.signUp.emailLabel" />
      <input
        id="email"
        type="email"
        autoComplete="email"
        className={inputClass(hasFieldError('email', errors, serverErrors))}
        placeholder={intl.formatMessage({ id: 'auth.signUp.emailPlaceholder' })}
        {...register('email' as Path<T>, { required: true })}
      />
      <FieldError field="email" errors={errors} serverErrors={serverErrors}
        messages={{ required: 'auth.signUp.emailRequired' }} />
    </div>
  );
}
